window.ScrollHint = require('scroll-hint');
import Quill from 'quill';
window.Quill = Quill;
window.Delta = require('quill-delta');

const QuillFontSizeList = ['8px','9px','10px','11px','12px','14px','16px','20px','24px','28px','36px','48px','72px'];
const Size = Quill.import('attributors/style/size');
Size.whitelist = QuillFontSizeList;
Quill.register(Size, true);

const QuillFontFamilyList = ['system-ui', 'sans-serif', 'arial', 'serif', 'monospace', 'Courier', 'cursive', 'Comic Sans MS','fantasy'];
const Font = Quill.import('attributors/style/font');
Font.whitelist = QuillFontFamilyList;
Quill.register(Font, true);

const Image = Quill.import('formats/image');
Image.className = 'img-fluid';
Quill.register(Image, true);

window.QuillFontSizeList = QuillFontSizeList;
window.QuillFontFamilyList = QuillFontFamilyList;
import QuillTableBetter from 'quill-better-table';
window.QuillTableBetter = QuillTableBetter;
Quill.register({
  'modules/better-table': QuillTableBetter
}, true);

const alignClass = Quill.import('attributors/style/align');
Quill.register(alignClass, true);

const backgroundClass = Quill.import('attributors/style/background');
Quill.register(backgroundClass, true);

const colorClass = Quill.import('attributors/style/color');
Quill.register(colorClass, true);

const directionClass = Quill.import('attributors/style/direction');
Quill.register(directionClass, true);
